import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Me',
    path: '/my-story'
  }, {
    name: 'Product Deep Dives',
    path: '/product-deep-dives'
  }, {
    name: "Let's Connect",
    path: '/contact'
  }];
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <nav className="bg-gray-900 shadow-sm sticky top-0 z-50" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="flex justify-between h-16" data-id="element-149">
          <div className="flex items-center" data-id="element-150">
            <Link to="/" className="flex-shrink-0 flex items-center" data-id="element-151">
              <span className="text-indigo-400 font-bold text-xl" data-id="element-152">
                Bhavini Sapra
              </span>
            </Link>
          </div>
          {/* Desktop menu */}
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-4" data-id="element-153">
            {navItems.map(item => <Link key={item.name} to={item.path} className={`px-3 py-2 rounded-md text-sm font-medium ${isActive(item.path) ? 'text-indigo-400 bg-gray-800' : 'text-gray-300 hover:text-indigo-400 hover:bg-gray-800'} transition duration-150 ease-in-out`} data-id="element-154">
                {item.name}
              </Link>)}
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-155">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-indigo-400 hover:bg-gray-800 focus:outline-none" aria-expanded="false" data-id="element-156">
              <span className="sr-only" data-id="element-157">Open main menu</span>
              {isOpen ? <XIcon className="h-6 w-6" data-id="element-158" /> : <MenuIcon className="h-6 w-6" data-id="element-159" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-gray-900 shadow-lg absolute w-full" data-id="element-160">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-161">
            {navItems.map(item => <Link key={item.name} to={item.path} className={`block px-3 py-2 rounded-md text-base font-medium ${isActive(item.path) ? 'text-indigo-400 bg-gray-800' : 'text-gray-300 hover:text-indigo-400 hover:bg-gray-800'} transition duration-150 ease-in-out`} onClick={() => setIsOpen(false)} data-id="element-162">
                {item.name}
              </Link>)}
          </div>
        </div>}
    </nav>;
};
export default Navbar;